export const QUERY_KEYS = {
  availableRoles: "PROJECT_TEAM_AVAILABLE_ROLES",
  allTeamMembersList: "PROJECT_TEAM_MEMBERS_ALL_TEAM_MEMBERS_LIST"
};
